module.exports = __webpack_public_path__ + "img/trash-3.e6028c0e.svg";